import { Link } from "react-router-dom";
import { FolderLock, ArrowRight, Lock } from "lucide-react";
import { t } from "../../lib/i18n";

export const DataRoomCard = ({ companyId, stage, isOwner = false }) => {
  const active = (stage || 1) >= 6;
  return (
    <section className={`hairline p-7 md:p-8 flex flex-wrap items-center justify-between gap-6 ${active ? "bg-[#1E3A5F] text-bone" : "bg-card"}`} data-testid="dataroom-card">
      <div className="flex items-start gap-4 max-w-2xl">
        <div className={`w-12 h-12 flex-shrink-0 flex items-center justify-center ${active ? "bg-white/10" : "bg-bone hairline"}`}>
          {active ? <FolderLock className="w-5 h-5 text-[#E4B54B]" /> : <Lock className="w-5 h-5 text-muted-foreground" />}
        </div>
        <div>
          <span className={`font-mono-label ${active ? "text-gold" : "text-muted-foreground"}`}>{t("Data Room · Pre-Due Diligence")}</span>
          <h3 className="font-serif-display text-xl md:text-2xl mt-1">
            {active ? t("Preguntas, respuestas y documentación de análisis") : t("El Data Room se activará en la etapa de Análisis")}
          </h3>
          <p className={`text-sm mt-1.5 leading-relaxed ${active ? "text-bone/75" : "text-muted-foreground"}`}>
            {isOwner
              ? t("Clasifica y responde las preguntas de los compradores por sección (Legal, Financiero, Fiscal, Laboral, Operacional, Otros) y publica la documentación habitual de esta fase.")
              : active
                ? t("Accede al Q&A organizado por secciones y a la documentación compartida por el vendedor con todos los compradores con NDA aprobado.")
                : t("Cuando la empresa alcance la Etapa 6, podrás consultar el Q&A y la documentación compartida por el vendedor.")}
          </p>
        </div>
      </div>
      {active && (
        <Link to={`/dataroom/${companyId}`} className={`rounded-none h-11 px-6 inline-flex items-center gap-2 font-medium text-sm transition-colors ${isOwner ? "bg-[#E0712C] hover:bg-[#C25F1E] text-white" : "bg-bone text-[#1E3A5F] hover:bg-white"}`} data-testid="open-dataroom-btn">
          {t("Abrir Data Room")}{" "}<ArrowRight className="w-4 h-4" />
        </Link>
      )}
    </section>
  );
};
